import { useIdleTimeout } from "@/hooks/use-idle-timeout";
import { useSidebarCollapsed } from "@/hooks/use-sidebar-collapsed";
import { useWeeklySummary } from "@/hooks/use-time-entries";
import { Footer } from "./Footer";
import { Sidebar } from "./Sidebar";

function getCurrentWeekMonday() {
  const today = new Date();
  const dow = today.getDay();
  const monOffset = dow === 0 ? -6 : 1 - dow;
  const mon = new Date(today);
  mon.setDate(today.getDate() + monOffset);
  return mon.toISOString().slice(0, 10);
}

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  useIdleTimeout();
  const week = getCurrentWeekMonday();
  const { data: summary } = useWeeklySummary(week);
  const flaggedCount = summary?.flaggedCount ?? 0;
  const [collapsed, toggleCollapsed] = useSidebarCollapsed();

  return (
    <div className={`app${collapsed ? " is-collapsed" : ""}`}>
      <Sidebar
        flaggedCount={flaggedCount}
        collapsed={collapsed}
        onToggleCollapsed={toggleCollapsed}
      />
      <div className="main">{children}</div>
      <Footer />
    </div>
  );
}
